var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card card__section",domProps:{"innerHTML":_vm._s(_vm.contentItem.text)}})
}
var staticRenderFns = []

export { render, staticRenderFns }